import { N0SsrPassengerUpdateRequest } from '@models/requests/ssr-passenger-update-request.model';
import { Action, createAction, props } from '@ngrx/store';

export const enum BagActionTypes {
  storeBagUpdateRequestKeepSame = '[bags] STORE_BAG_UPDATE_REQUEST_KEEP_SAME',
  storeBagUpdateRequest = '[bags] STORE_BAG_UPDATE_REQUEST',
  sellBagSsrsWithoutStepCompletion = '[bags] SELL_BAG_SSRS_WITHOUT_STEP_COMPLETION',
  sellBagSsrs = '[bags] SELL_BAG_SSRS',
  sellBagSsrsSuccess = '[bags] SELL_BAG_SSRS_SUCCESS',
  sellBagSsrsCheckInSuccess = '[bags] SELL_BAG_SSRS_CHECK_IN_SUCCESS',
  validateBagSelection = '[bags] VALIDATE_BAG_SELECTION',
  clearTotalSelectionsState = '[bags] CLEAR_TOTAL_SELECTION_STATE',
}

export const bagStoreBagUpdateRequestKeepSame = createAction(
  BagActionTypes.storeBagUpdateRequestKeepSame,
  props<{ payload: N0SsrPassengerUpdateRequest[] }>(),
);

export const bagStoreBagUpdateRequest = createAction(
  BagActionTypes.storeBagUpdateRequest,
  props<{ 
    payload: N0SsrPassengerUpdateRequest; 
    keepSameBags: boolean;
  }>(),
);

export const bagsSellBagSsrsWithoutStepCompletion = createAction(BagActionTypes.sellBagSsrsWithoutStepCompletion,
  props<{
    payload: N0SsrPassengerUpdateRequest[],
    next?: Action
  }>(),
);

export const bagsSellBagSsrs = createAction(
  BagActionTypes.sellBagSsrs,
  (payload: {redirect: boolean, redirectToPayment?: boolean} = {redirect: true}) => payload,
);

export const bagsSellBagSsrsSuccess = createAction(
  BagActionTypes.sellBagSsrsSuccess,
  (payload: {redirect: boolean, redirectToPayment?: boolean} = {redirect: true}) => payload,
);

export const bagsSellBagSsrsCheckInSuccess = createAction(
  BagActionTypes.sellBagSsrsCheckInSuccess,
);

export const bagsValidateBagSelection = createAction(
  BagActionTypes.validateBagSelection,
  (payload: {redirect: boolean, redirectToPayment?: boolean} = {redirect: true}) => payload,
);

export const bagsClearTotalSelectionsState = createAction(
  BagActionTypes.clearTotalSelectionsState,
);
